import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import getProfilePicture from "../../../../_selectors/userSelectors/getProfilePicture";
import getDisplayName from "../../../../_selectors/userSelectors/getDisplayName";
import getMyFollowersCount from "../../../../_selectors/userSelectors/getMyFollowersCount";
import getMyLikesCount from "../../../../_selectors/userSelectors/getMyLikesCount";

class ProfileHeader extends Component {
  render() {
    const { profilePic, name, likes, followers, tagLine } = this.props;
    return (
      <div class="profile profile-transparent tour-step-1">
        <div class="profile-image">
          <img src={profilePic} />
          <div class="profile-badges">
            <Link
              to="/people-who-liked-me"
              className="profile-badges-left tip tour-step-one"
              title={`Members who have liked your profile`}
            >
              <i class="fa fa-thumbs-up" /> {` ${likes}`}
            </Link>
            <Link
              to="connected-members"
              className="profile-badges-right tip tour-step-two"
              title="Members with whom you are connected"
            >
              <i class="fa fa-heartbeat" /> {` ${followers}`}
            </Link>
          </div>
        </div>
        <div class="profile-info">
          <h4>{name}</h4>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state, ownProps) => ({
  profilePic: getProfilePicture(state),
  name: getDisplayName(state),
  likes: getMyLikesCount(state),
  followers: getMyFollowersCount(state)
});

export default connect(mapStateToProps)(ProfileHeader);



// WEBPACK FOOTER //
// ./src/_components/Layout/Sidebar/ProfileHeader/index.js